namespace GeniuzPOS.Purchase {
    export interface PoPayTermCodeForm {
        PayTermCode: Serenity.StringEditor;
        PayTermDesc: Serenity.StringEditor;
        CreditTerm: Serenity.IntegerEditor;
    }

    export class PoPayTermCodeForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPayTermCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoPayTermCodeForm.init)  {
                PoPayTermCodeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(PoPayTermCodeForm, [
                    'PayTermCode', w0,
                    'PayTermDesc', w0,
                    'CreditTerm', w1
                ]);
            }
        }
    }
}
